import _ from 'lodash'

export function formatTrains(trains) {
  return _.reduce(
    trains,
    (trainsMap, train) => ({
      ...trainsMap,
      [`${_.get(train, 'id')}`]: {
        id: _.get(train, 'id'),
        amenities: {
          ...(_.get(train, 'accommodations') && {
            accommodations: _.get(train, 'accommodations'),
          }),
          ...(_.get(train, 'checkin') && { checkIn: _.get(train, 'checkin') }),
          ...(_.get(train, 'dining') && { dining: _.get(train, 'dining') }),
          ...(_.get(train, 'luggage') && { luggage: _.get(train, 'luggage') }),
          ...(_.get(train, 'notableScenery') && {
            notableScenery: _.get(train, 'notableScenery'),
          }),
        },
        description: _.get(train, 'hero.description'),
        images: _.get(train, 'images'),
        link: _.get(train, 'link'),
        thumbnail: _.get(train, 'thumbnail') || _.get(train, 'images[0]'),
        title: _.get(train, 'title'),
      },
    }),
    {}
  )
}
